import {Injectable, signal} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PlatformService {
  public isBrowser = signal<boolean>(false);
  public isRendered = signal<boolean>(false);
  public isNextRendered = signal<boolean>(false);
}
